/**
 * SiteCapabilities Component - Displays site operating capabilities
 * Requirements: 2.2
 */

import { SiteCapabilities as SiteCapabilitiesType } from '../services/api';

interface SiteCapabilitiesProps {
  capabilities: SiteCapabilitiesType;
}

function SiteCapabilities({ capabilities }: SiteCapabilitiesProps) {
  return (
    <div style={styles.container}>
      <div style={styles.grid}>
        <div style={styles.item}>
          <span style={styles.label}>Operating Schedule</span>
          <span style={styles.value}>{capabilities.operatingSchedule}</span>
        </div>

        <div style={styles.item}>
          <span style={styles.label}>Production Lines</span>
          <span style={styles.value}>
            {capabilities.activeLines} active / {capabilities.totalLines} total
          </span>
        </div>

        <div style={styles.item}>
          <span style={styles.label}>Minimum Order Quantity</span>
          <span style={styles.value}>
            {capabilities.minimumOrderQuantity.toLocaleString()} cases
          </span>
        </div>

        <div style={styles.itemFull}>
          <span style={styles.label}>Available Formats</span>
          <div style={styles.formatList}>
            {capabilities.availableFormats.map((format) => (
              <span key={format} style={styles.formatTag}>
                {format}
              </span>
            ))}
          </div>
        </div>

        <div style={styles.itemFull}>
          <span style={styles.label}>Description</span>
          <p style={styles.description}>{capabilities.description}</p>
        </div>
      </div>
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  container: {
    padding: '0.5rem 0',
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '1rem',
  },
  item: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.25rem',
  },
  itemFull: {
    gridColumn: '1 / -1',
    display: 'flex',
    flexDirection: 'column',
    gap: '0.25rem',
  },
  label: {
    fontSize: '0.8rem',
    color: '#666',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
  },
  value: {
    fontSize: '0.95rem',
    color: '#333',
  },
  formatList: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '0.5rem',
    marginTop: '0.25rem',
  },
  formatTag: {
    display: 'inline-block',
    padding: '0.25rem 0.5rem',
    backgroundColor: '#e9ecef',
    borderRadius: '4px',
    fontSize: '0.85rem',
    color: '#495057',
  },
  description: {
    margin: 0,
    fontSize: '0.9rem',
    color: '#555',
    lineHeight: 1.5,
  },
};

export default SiteCapabilities;
